import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import DateRangeIcon from '@material-ui/icons/DateRange';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  }
}));

export default function HowItWorksAccordion() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading}>
            Click here to read the introduction to our train along concept
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
        <Typography >
          Start by preparing the equipment needed for your exercises.
          <br/> <br/>You will need: <list>
              <br/>*<br/>*<br/>*<br/>
            </list>
          </Typography>
          <Typography style={{marginLeft: 30}}>
          Then watch the short video introduction of the planned exercises for this session by clicking on the play icon for each exercise.
          <br/>When you are ready, begin your exercises by clicking the "Begin" session button to the right.
          <br/>You can broadcast to bigger screen if want or simply train along watching the screen of your smartphone, tablet, laptop or stationary computer. 
          <br/>In general no warm-up is required. You can train along from the beginning of the session.
          <br/>You can always pause or restart your program if you need to, however it is not possible to fast forward or skip the exercises, as our algorithm tracks your compliance with the program.
          <br/>If you need to stop the exercise, press the alert notification icon in the upper right corner and provide feedback for the exercise. 
          <br/><br/>If you need further assistance you can always book a consultation with one of our physiotherapists.
          <br/>Click the calendar icon to open our booking system<IconButton><DateRangeIcon style={{marginTop: 0, marginBottom: 2, color: "#002D55"}}></DateRangeIcon> </IconButton>
          </Typography>
        </AccordionDetails>
      </Accordion>
      
    </div>
  );
}
